import factory from './factory';
import { ItemMixin } from './mixins';
import bus from '../utils/eventBus';
export default {
  mixins: [ItemMixin],
  computed: {
    itemStyle() {
      const {
        options
      } = this.element;

      if (this.inline) {
        return options.width ? {
          'flex-basis': `${options.width}%`
        } : {}; // 内联表单宽度计算
      }

      if (this.cols) {
        const {
          col
        } = options;
        const widthPercent = col ? col / this.cols : 1 / this.cols;
        return {
          // ie下面flex-basis：50%并不平分，减去2%以兼容ie
          flex: `1 0 ${(widthPercent > 1 ? 1 : widthPercent) * 100 - 2}%`
        };
      }

      return {
        width: options.width ? `${options.width}%` : '100%'
      };
    },

    componentCls() {
      const {
        xtype
      } = this.element;
      return factory.getControl(xtype);
    }

  },

  created() {
    bus.$on('change', this.handleChange);
  },

  beforeDestroy() {
    bus.$off('change', this.handleChange);
  },

  methods: {
    handleChange(...args) {
      const control = this.$refs.control || {};

      if (control.handleFormChange) {
        control.handleFormChange(...args);
      }
    }

  }
};